jQuery("#rastrearP").click(function(){
              var guia = jQuery("#guiaPaquete").val();
              if(guia != ""){
                var url = "https://www.paquetexpress.com.mx/rastreo/" + guia
                window.open(url, '_blank');
              }else{
                alert("El campo 'Numero de Guía no debe esta vacio.'");
              }
              
            });

jQuery(document).ready(function(){  
  
jQuery('#support_register_form').submit(function (ev) {
      
      if(jQuery('#yusdInt').val() == 'qGphJD'){
      
        jQuery.ajax({
              type: jQuery('#support_register_form').attr('method'), 
             url: jQuery('#support_register_form').attr('action'),
              data: new FormData(this),
              contentType: false,
              cache: false,
              processData:false,
              beforeSend: function(){
              jQuery('#loaderSa').css("display","block");
          },
              success: function (data) {
                //alert(data); 
                //jQuery('#loaderSa').css("display","none");
				jQuery("#content_msg_sa").html("");
  				jQuery("#content_msg_sa").html('<p>' + data + '</p><p><button class="kafa__bton kafa__bton__red" id="closed_msg_s">Cerrar</button></p>');
                jQuery("#closed_msg_s").click(function(){
					location.reload();
				});                
            } 
              
        });	  
        
      }else{
      	alert("La captcha es incorrecta, favor de verificar!");
      }
      ev.preventDefault();

      
	});
jQuery("#evidencias_pro").change(function(){
        var fileLength = this.files.length;
        var match= ["image/jpeg","image/png","image/jpg","image/gif"];
        var i;
        for(i = 0; i < fileLength; i++){ 
            var file = this.files[i];
            var imagefile = file.type;
            if(!((imagefile==match[0]) || (imagefile==match[1]) || (imagefile==match[2]) || (imagefile==match[3]))){
                alert('Por favor seleccione un formato valido de imagen (JPEG/JPG/PNG/GIF).');
                jQuery("#evidencias_pro").val('');
                return false;
            }
        }
   });

  jQuery(document).ready(function(){
    jQuery('#contactanos_form').submit(function (ev) {
      
        jQuery.ajax({
              type: jQuery('#contactanos_form').attr('method'), 
              url: jQuery('#contactanos_form').attr('action'),
              data: new FormData(this),
              contentType: false,
              cache: false,
              processData:false,
              beforeSend: function(){
              jQuery('#loaderSa').css("display","block");
          },
              success: function (data) {
                //alert(data); 
                //jQuery('#loaderSa').css("display","none");
				jQuery("#content_msg_sa").html("");
  				jQuery("#content_msg_sa").html('<p>' + data + '</p><p><button class="kafa__bton kafa__bton__red" id="closed_msg_s">Cerrar</button></p>');
                jQuery("#closed_msg_s").click(function(){
					location.reload();
				});                
            } 
              
        });	  
      ev.preventDefault();

      
	});
  });

  jQuery('#video_src').click(function(){jQuery('.flotante').slideToggle('slow'); document.getElementById("video_central").play(); });
  jQuery(".btn_closet_video").click(function(){	jQuery('.flotante').slideToggle('slow'); document.getElementById("video_central").pause(); });
  jQuery(".kafa__proudcts_courusell-desktop").click(function(){ var a = jQuery(this).attr('data-fist'); var b = jQuery(this).attr('data-bigs'); jQuery("#imgp-firts-desktop").attr('src',a); jQuery("#bigimage").attr('src',b);});
  

});

jQuery("button[data-info^='#delete_']").click(function(){
	var yu = jQuery(this).attr('data-info');
    jQuery("#aceptDl").attr('data-dl-acept', yu);
});

jQuery("#aceptDl").click(function(){
    var id = jQuery(this).attr('data-dl-acept');
    jQuery(id).submit();
});

jQuery("#btnfilgd button").click(function(){
	jQuery("#panel_filtros").toggle(500);
});

jQuery("button[data-form-id^='.panel-oscuro_']").click(function(){
	var so = jQuery(this).attr('data-form-id');
    console.log(so);
	jQuery(so).show(300);
})

jQuery("a[id^='closedEditAddress_']").click(function(){
	var t = jQuery(this).attr("data-form-id");
    jQuery(t).hide(300);
})

//jQuery("div")

function getIns(){
  jQuery("#searchAll").click(function(){
    jQuery("form[action='/search']").submit();
    console.log('hola-mundo');
  });    
}
function get_cart_(){
     	const formato = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 2 });     
		$.ajax({type: 'GET',url: '/cart.js',dataType: 'json'}).done(function(cart){jQuery("#car_item_total").html(cart.item_count);var pt = cart.total_price;pt=pt.toString().slice(0,-2);jQuery("#total_cart_list").html('$'+formato.format(pt)+".00"); var item = '';jQuery.each( cart.items, function( i, val ) {var ps =  val.price;ps =  ps.toString().slice(0,-2);item += "<div class='row p-2'><div class='col-6'><img src='" + val.image + "' class='w-100 p-2'></div>" + "<div class='col-6'><p>" + val.product_title + "</p><p>Cant: " + val.quantity + "</p>" + "<div class='row'><div class='col-9'><label>$ " + formato.format(ps) + ".00</label></div>" + "<div class='col-3'><button data-type-btn='remove' data-id='"+ val.variant_id +"' class='btn btn-sm'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path d='M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z' fill='currentColor'/><path d='M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z' fill='currentColor'/></svg></button></div></div></div></div>";});jQuery("#pnl_cart_items").html(item);get_insta_btn();}).fail(function(jqXHR, textStatus, errorThrown){title = '<h4 style="color:#be0027;">'+ jqXHR.responseJSON.message + '</h4>',content = '<p style="color:#000;">' + jqXHR.responseJSON.description + '</p>';});
    } 
	
    function get_insta_btn(){
        jQuery("button[data-type-btn='remove']").click(function(){
            var itm = jQuery(this).attr('data-id');
			increase_decrease_quantity(0,itm,'na');
          	
          	const myInterval = setInterval(function(){
				get_cart_();
                clearInterval(myInterval);
            }, 500);
          
            
        });
    }

    jQuery("#menu-first li").mouseenter( function(){ 
      var ids = jQuery(this).attr('data-poli-p');
      jQuery("#" + ids).addClass("show");
      jQuery("#" + ids).attr("aria-expanded",'true');
      jQuery("ul[aria-labelledby='"+ ids +"']").addClass('show');
      jQuery("ul[aria-labelledby='"+ ids +"']").attr('data-bs-popper',"static");
      
      
    }).mouseleave( function(){ 
      var ids = jQuery(this).attr('data-poli-p');
      jQuery("#" + ids).removeClass("show");
      jQuery("#" + ids).attr("aria-expanded",'false');
      jQuery("ul[aria-labelledby='"+ ids +"']").removeClass('show');
      jQuery("ul[aria-labelledby='"+ ids +"']").removeAttr('data-bs-popper');
    });
    
    jQuery("button[name='minus']").click(function(){
      
      var oi = jQuery(this).attr("data-io");
      var qty = parseInt(jQuery(this).attr("data-qty")) - 1;
	  var dataKey = jQuery(this).attr("data-inf");
      increase_decrease_quantity(qty, oi, dataKey)
      
    })
    
     jQuery("button[name='plus']").click(function(){
      
      var oi = jQuery(this).attr("data-io");
      var qty = parseInt(jQuery(this).attr("data-qty")) + 1;
	  var dataKey = jQuery(this).attr("data-inf");
      increase_decrease_quantity(qty, oi, dataKey)
      
    })
	
	function increase_decrease_quantity(qty, variant_id, dataKey){
      $.ajax({
           type: 'POST',
           url: '/cart/change.js',
           dataType: 'json',
           data: {
               quantity: qty,
               id: variant_id
           }
      }).done(function(cart){
			jQuery("#car_item_total").html(cart.item_count);
        
            if(dataKey != 'na'){
				window.location.reload();
            }
            //location.href = location.href;

      }).fail(function(jqXHR, textStatus, errorThrown){
            //console.log(textStatus +  " - "  + errorThrown);
           //serrorFunction(); 
      });

    }
	
	jQuery(document).ready(function(){
      jQuery("#closed_panel_cart_list").click(function(){
          jQuery(".panel-pa-cart-items").toggle(150,'linear');

      });
      jQuery("#panel_cart_list_gd").click(function(){
          get_cart_();
      	  jQuery(".panel-pa-cart-items").toggle(100,'linear');
      });
      
      get_insta_btn();
      	
    });

    	
	 const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
     const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));	
	 /* funcion del scroll */
	  window.onscroll = function() {
           let getscroll = window.pageYOffset;
           let ventana_ancho = $(window).width();
           if(ventana_ancho > 1299){
               if( getscroll > 90 ){
                //jQuery("#menuprincipal").addClass('hd-main-gd');
                 document.getElementById('menuprincipal').style.position = 'fixed';
               }else{
                 document.getElementById('menuprincipal').style.position = 'relative';
                //jQuery("#menuprincipal").removeClass('hd-main-gd');
               }
           }else{
           	   if( getscroll > 200 ){
                //jQuery("#menuprincipal").addClass('hd-main-gd');
                 document.getElementById('menuprincipal').style.position = 'fixed';
               }else{
                 document.getElementById('menuprincipal').style.position = 'relative';
                //jQuery("#menuprincipal").removeClass('hd-main-gd');
               }
           
           }
        }
      /* funcion del scroll end */
      /* funcion del mostrar vista grande modal producto */
         jQuery("button[data-gd-inf='view-pd-info']").click(function(){
          let id = jQuery(this).attr('data-idf-gd');
          //console.log(id);
          let url = jQuery(id + ' .t-pro-gd a').attr('href');
          let title = jQuery(id + ' .t-pro-gd a').attr('data-title-cp');
          let vendor = jQuery(id + ' .badge.rounded-pill.text-bg-info').html();
          let image = jQuery(id + ' img.w-100.p-4').attr('data-img-big');
          let price = jQuery(id + ' .price-gd').html();
          let desc = jQuery(id + ' div[data-desc="true"]').html();
          let sku = jQuery(id + ' input[data-p-gd-cir="sku"]').val();
          let idp = jQuery(id + ' input[data-p-gd-cir="id"]').val();

          jQuery("#image-mdl").attr("src",image);
          jQuery("#vendor-mdl").html(vendor);
          jQuery("#title-mdl").html(title);
          jQuery("#title-mdl").attr("href",url);
          jQuery("#prices-mdl").html(price);
          jQuery("#descp-mdl").html(desc);
          jQuery("#sku-mdl").html(sku);
           console.log(idp);
           if(idp){
          	 jQuery("#pgd-id-dg_op").val(idp);
          	 jQuery("#pgd-id-dg_op").attr("data-sku", sku);
             jQuery("#product_form_modal button").removeAttr("disabled", "disabled");  
           }else{
           	 jQuery("#product_form_modal button").attr("disabled", "disabled");  
           }
             
          
           
          jQuery("#see_pd_gd").attr("href",url);

        });
      /* funcion del mostrar vista grande modal producto fin*/
	  /* funcion cambio de vista del producto */
        jQuery("#list").click(function(){
              jQuery("#list-supof .col-12.col-sm-6.col-md-6.col-lg-3.col-xl-3.col-xxl-3.col-gd_xxl.p-3.mb-3.pd-item-gd.position-relative").each(function(){
              	let info = jQuery(this).attr('id'); 
                console.log(info);
                jQuery("#" + info).attr('class','');
                jQuery("#" + info).addClass('col-12 col-sm-6 col-md-6 col-lg-12 col-xl-12 col-xxl-12 p-3 mb-3 pd-item-gd position-relative');
                jQuery("#" + info + ' div[data-inf-pd^="vendor-grid"]').addClass("d-none");
                jQuery("#" + info + ' div[data-inf-pd="title-grid"]').addClass("d-none");
                jQuery("#" + info + ' div[data-inf-pd="image-ctr-pd-gd"]').addClass("col-md-4");
                jQuery("#" + info + ' div[data-inf-pd="content-info-pd-gd"]').addClass('col-md-8');
                jQuery("#" + info + ' div[data-inf-pd="vendor-list"]').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="title-list"]').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="title-list"] p').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="descr-list"] div').removeClass('d-none');
                jQuery("#" + info + ' hr[data-inf-pd="line_divided_pd"]').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd"]').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd1"]').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd2"]').addClass('d-none');
                
              });
              
          });
          jQuery("#grid").click(function(){
              jQuery("#list-supof .col-12.col-sm-6.col-md-6.col-lg-12.col-xl-12.col-xxl-12.p-3.mb-3.pd-item-gd.position-relative").each(function(){
              	let info = jQuery(this).attr('id');                 
                jQuery("#" + info).attr('class','');
                jQuery("#" + info).addClass('col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 col-gd_xxl p-3 mb-3 pd-item-gd position-relative');
                jQuery("#" + info + ' div[data-inf-pd="vendor-grid"]').removeClass("d-none");
                jQuery("#" + info + ' div[data-inf-pd="title-grid"]').removeClass("d-none");
                jQuery("#" + info + ' div[data-inf-pd="image-ctr-pd-gd"]').removeClass("col-md-4");
                jQuery("#" + info + ' div[data-inf-pd="content-info-pd-gd"]').removeClass('col-md-8');
                jQuery("#" + info + ' div[data-inf-pd="vendor-list"]').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="title-list"]').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="title-list"] p').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="descr-list"] div').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd"]').addClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd1"]').removeClass('d-none');
                jQuery("#" + info + ' div[data-inf-pd="bton-list-gd2"]').removeClass('d-none');
                jQuery("#" + info + ' hr[data-inf-pd="line_divided_pd"]').addClass('d-none');
                
              });
              
          });
      /* funcion cambio de vista del producto fin*/
      /* funcion creacion de cookies */
          jQuery("#add-wishlist").click(function(){
			
            let id = jQuery(this).attr('data-wls-pd-gd');
            let url = jQuery(id + ' .t-pro-gd a').attr('href');
            let title = jQuery(id + ' .t-pro-gd a').attr('data-title-cp');
            let vendor = jQuery(id + ' .badge.rounded-pill.text-bg-info').html();
            let image = jQuery(id + ' img.w-100.p-5').attr('data-img-big');
            let price = jQuery(id + ' .price-gd').html();
            let desc = jQuery(id + ' div[data-desc="true"]').html();
            let sku = jQuery(id + ' input').val();
            
            let complete = url + "|" + title + "|" + vendor + "|" + image + "|" + price + "|" + desc + "|" + sku;
            
            setCookie(id, complete, 7);
            
            
          });
      
      	   //función para crear la cookie
          function setCookie(cname, cvalue, exdays) {
              var d = new Date();
              d.setTime(d.getTime() + (exdays*24*60*60*1000));
              var expires = "expires="+ d.toUTCString();
              document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
          }

          //función para leer la cookie
          function getCookie(cname) {
              var name = cname + "=";
              var decodedCookie = decodeURIComponent(document.cookie);
              var ca = decodedCookie.split(';');
              for(var i = 0; i <ca.length; i++) {
                  var c = ca[i];
                  while (c.charAt(0) == ' ') {
                      c = c.substring(1);
                  }
                  if (c.indexOf(name) == 0) {
                      return c.substring(name.length, c.length);
                  }
              }
              return "";
          }

          //función para validar una cookie
		 
          function checkCookie() {
              var user = getCookie("username");
              if (user != "") {
                  alert("Welcome again " + user);
              } else {
                  user = prompt("Please enter your name:", "");
                  if (user != "" && user != null) {
                      setCookie("username", user, 365);
                  }
              }
          }
      /* funcion creacion de cookies fin */
      /* funcion add products cart */
		function add_pd_gds(){
          jQuery("form[id^='add_pd_gd_'] button").click(function(event) {
              var gip = jQuery(this).attr('data-add-info-id');
              var qtys = jQuery(gip + " input[name='quantity']").val();
              event.preventDefault();            
               $.ajax({
                   type: 'POST',
                   url: '/cart/add.js',
                   dataType: 'json',
                   data: jQuery(gip).serialize()
                }).done(function(cart){
                  let price__for__pz = format_cat(parseFloat(cart.final_price / 100).toFixed(2));
                  title ='<h4 class="alert_title_pgds_dg">¡Producto agregado al carrito!</h4>',
                  content = '<table><tr><td style="padding-left: 10px; padding-right: 10px;"><img src="' + cart.image + '" style="width: 120px;"></td><td style="padding-left: 20px; padding-right: 10px;font-size:12px;"><b style="color:#000;"> ' + cart.product_title + '</b><p class="price-price--highlight" style="font-size: 15px; color: #e1041c!important; text-shadow: 0 0 black;">' + price__for__pz + '</p></td></tr></table>';
                  alert_add_pd_gd(title,content);
                  var pds = jQuery("#car_item_total").html();
                      pds = parseInt(pds) + parseInt(qtys);
                      jQuery("#car_item_total").html(pds);
                      jQuery("#car_item_total_m").html(pds);

                }).fail(function(jqXHR, textStatus, errorThrown){
                  title = '<h4 style="color:#be0027; font-size:14px;">'+ jqXHR.responseJSON.message + '</h4>',
                    content = '<p style="color:#000; font-size:12px;">' + jqXHR.responseJSON.description + '</p>'
                  alert_add_pd_gd(title,content);
                });            

            });
		}      	  
      add_pd_gds();

	  function format_cat(cant_va){  
         const exp = /(\d)(?=(\d{3})+(?!\d))/g;
         const rep = '$1,';
         return "$ " + cant_va.toString().replace(exp,rep);
      }
      
      function alert_add_pd_gd(title, content){
      
        jQuery("#title_alert_pd_gd").html(title);
        jQuery("#body_alert_pd_gd").html(content);
        jQuery("#alert_add_pdg_gd").show();
        //const myInterval = setInterval(myTimer, 5000);
      	
      }
      
      jQuery("#close_alert_pd_gd").click(function(){
      	jQuery("#alert_add_pdg_gd").hide();
      });
      
      $('#alert_add_pdg_gd').on('click', function(e) {
        if (e.target !== this)
          return;  
        jQuery("#alert_add_pdg_gd").hide();
      });

	  $('#resultSearch').on('click', function(e) {
        if (e.target !== this)
          return;  
        jQuery("#resultSearch").hide();
      });
      

      function myTimer() {
        jQuery("#alert_add_pdg_gd").hide();
        clearInterval(myInterval);
      }
	 /* funcion add products cart */

	 jQuery("#search_movile_gd").click(function(){
        let pod = jQuery(this).attr('data-active');
        if(pod == "active"){
        	jQuery(this).html('<i class="fa-solid fa-xmark"></i>');
  	 		jQuery(".search_pd_gd_mv").toggle(500);
            jQuery(this).attr('data-active','disabled');
        }else{
        	jQuery(this).html('<i class="fa-solid fa-magnifying-glass" data-bs-toggle="tooltip" title="Buscar"></i>');
  	 		jQuery(".search_pd_gd_mv").toggle(300);
            jQuery(this).attr('data-active','active');
        }
  	 });
    function removeClassimg(){
      jQuery("#mini_img .col-2").each(function(){
          jQuery(this).removeClass("activateImg");
        });
    }
    function chage_img (){
      jQuery("#mini_img .col-2 img").click(function(){
        removeClassimg();
        var typo = jQuery(this).attr("data-content-id");
        jQuery(typo).addClass("activateImg");
		var m = jQuery(this).attr('data-bg-image');
        jQuery("#image-prin-pd-gd").attr("src",m);
      })
    }
	chage_img ();
    function generate_js (){

      jQuery(".card_tags__collection_body h4 a").click(function(){

          var dp = jQuery(this).attr("data-id");
          jQuery(dp).toggle(300);

      })

    }
    generate_js ();
	
    function cli_tindOf(){
        jQuery("#tiendas_ofi .item_bnn_tienda").click(function(){
          
          jQuery("#tiendas_ofi .item_bnn_tienda").each(function(){
          	jQuery(this).attr('class', "col-4 item_bnn_tienda offline");
          });
          jQuery(this).attr('class', "col-4 item_bnn_tienda selected");

        });
    }

	cli_tindOf();
    jQuery("#ColFilter-Disponibilidad-1").click(function(){
		jQuery("#FacetFiltersForm").submit();
    });
    jQuery("#ColFilter-Disponibilidad-2").click(function(){
		jQuery("#FacetFiltersForm").submit();
    });

	jQuery("#Filter-Disponibilidad-1").click(function(){
		jQuery("#FacetFiltersForm").submit();
    });
    jQuery("#Filter-Disponibilidad-2").click(function(){
		jQuery("#FacetFiltersForm").submit();
    });
           
	/*jQuery("input[id^='Filter-Disponibilidad']").click(function(){
      var q =  jQuery(this).attr('data-avtive'); 
      var a = jQuery(this).val();
      var c = "?q=" + jQuery("#busqueda_result").val();
      if(q == 'false'){ 
          c += '&filter.v.availability=' + a; 
          if(a == 1){
              if( jQuery('#Filter-Disponibilidad-2').attr('checked') ) { 
                  c += '&filter.v.availability=0' 
              } 
          }else{
              if( jQuery('#Filter-Disponibilidad-1').attr('checked') ) { 
                  c += '&filter.v.availability=1' 
              }             
          }
          srt = jQuery("#SortBy").val();
          c += "&sort_by=" + srt;

      }else{
          if(a == 1){
              if( jQuery('#Filter-Disponibilidad-2').attr('checked') ) { 
                  c += '&filter.v.availability=0' 
              } 
          }else{
              if( jQuery('#Filter-Disponibilidad-1').attr('checked') ) { 
                  c += '&filter.v.availability=1' 
              }             
          }
          srt = jQuery("#SortBy").val();
          c += "&sort_by=" + srt;
      }
      
      var ps1 = jQuery("#Filter-Precio-GTE").val();
      var ps2 = jQuery("#Filter-Precio-LTE").val();
        c += "&filter.v.price.gte=" + ps1 + "&filter.v.price.lte=" + ps2;
      
      window.location.href= '/search' + c;
  });*/
	
    jQuery("#SortBy2").change(function(){
		jQuery("#FacetFiltersForm").submit();
    })
    jQuery("#SortBy").change(function(){
		jQuery("#FacetFiltersForm").submit();
    })
    /*jQuery("#SortBy").change(function(){
        var p = jQuery(this).val();
        var c = "?q=" + jQuery("#busqueda_result").val();
            c += "&sort_by=" + p;
        jQuery("input[name='filter.v.availability']").each(function(){
            var a = jQuery(this).val();
            if(jQuery(this).attr('checked')){

                c += '&filter.v.availability=' + a;            
            }

        })
        
        var ps1 = jQuery("#Filter-Precio-GTE").val();
        var ps2 = jQuery("#Filter-Precio-LTE").val();
        c += "&filter.v.price.gte=" + ps1 + "&filter.v.price.lte=" + ps2;
        
        window.location.href = "/search" + c;    
    });*/








window.onload = function(){
	slideOne();
	slideTwo();
}
const formatter = new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0
    })
let minGap = 0;
function slideOne(){
  
  if(parseInt(jQuery('#Filter-Precio-LTE').val()) - parseInt(jQuery('#Filter-Precio-GTE').val()) <= minGap){
    
    console.log(jQuery('#Filter-Precio-LTE').val());
  	jQuery('#Filter-Precio-GTE').val(parseInt(jQuery('#Filter-Precio-LTE').val()) - minGap);
  }
  
  jQuery("#range1").text(formatter.format(jQuery('#Filter-Precio-GTE').val()));
  
}

function slideTwo(){
  if(parseInt(jQuery('#Filter-Precio-LTE').val()) - parseInt(jQuery('#Filter-Precio-GTE').val()) <= minGap){
    console.log(jQuery('#Filter-Precio-GTE').val());
  	jQuery('#Filter-Precio-LTE').val(parseInt(jQuery('#Filter-Precio-GTE').val()) + minGap);
  }
  jQuery("#range2").text(formatter.format(jQuery('#Filter-Precio-LTE').val()));
}


jQuery("#btnRecover").click(function(){
  	jQuery("form[action='/account/recover']").removeClass('d-none');
    jQuery("form[action='/account/login']").addClass('d-none');
  })
  jQuery("#btnLogin").click(function(){
    jQuery("form[action='/account/recover']").addClass('d-none');
    jQuery("form[action='/account/login']").removeClass('d-none');
  })  
  
  
  jQuery("#acceptTerms").click(function(){
    var vd = jQuery(this).val();
    if(vd == 'false'){
    	jQuery("#rgsubmit").removeAttr('disabled');
        jQuery(this).val('true');
    }else{
    	jQuery("#rgsubmit").attr('disabled',"disabled");
        jQuery(this).val('false');
    }
  });
var currentUrl = new URL(window.location.protocol + '//' + window.location.host);  
jQuery("#predictiveSearch").on('paste', function(e) {	getValSearch(e.originalEvent.clipboardData.getData('text')); });
jQuery("#predictiveSearch").keyup(function(){ var a = jQuery(this).val(); getValSearch(a); });
jQuery("#predictiveSearch").focusout(function(){ var a = jQuery(this).val(); if(a == ""){ jQuery("#resultSearch").html(""); } jQuery("#resultSearch").fadeIn(300);});

function getValSearch(e){    
     fetch(currentUrl + "search?view=ajax&q=" + e + "&type=product&options%5Bunavailable_products%5D=hide", {
          method: 'GET',
          credentials: 'same-origin'
        }).then(function (response) {
          response.text().then(function (content) {
            var linkSearchResults = document.querySelector('#resultSearch');
            if (linkSearchResults && content.trim() !== '') {
              	linkSearchResults.innerHTML = content;
                jQuery("#resultSearch").fadeIn(200);
              	getIns();              
                jQuery( "ul#searchConsole li" ).focus(function(){
                     jQuery("#resultSearch").fadeIn(300);
                });
            }else{
              	linkSearchResults.innerHTML = '<div class="col-6 p-2" style="background-color: #fff;margin:auto; border:1px solid #eee"><div class="search-bar__result-products p-4"><h1 style="font-size:14px;" class="p-5 w-100">No se encontrarón resultados.</h1></div></div>';
                jQuery("#resultSearch").fadeIn(300);
            }        
            
            jQuery( "ul#searchConsole li" ).focusout(function(){
            	// jQuery("#resultSearch").fadeOut(600);
            });
            
          });
        });    
  }

$(document).ready(function(){ irArriba(); }); //Hacia arriba

function irArriba(){
  $('.ir-arriba').click(function(){ $('body,html').animate({ scrollTop:'0px' },500); });
  $(window).scroll(function(){
    if($(this).scrollTop() > 0){ $('.ir-arriba').slideDown(600); }else{ $('.ir-arriba').slideUp(600); }
  });
  $('.ir-abajo').click(function(){ $('body,html').animate({ scrollTop:'1000px' },1000); });
}

////////////////////////////// send RVCP ///////////////////////////////////////////////

const myInterval = setInterval(myTimer, 3000);
var cp = 1;
function myTimer() {
  jQuery("input.spr-button.spr-button-primary.button.button-primary.btn.btn-primary").click(function(){

        var a = jQuery("input[name='review[author]']").val();
        var b = jQuery("input[name='review[email]']").val();
        var c = jQuery("input[name='review[title]']").val();
        var d = jQuery("textarea[name='review[body]']").val();
        //console.log("Click Btn");

        if(a != "" && b != "" && c != "" && d != ""){
          
          var a = jQuery(".spr-form-input.spr-starrating a:first-child").hasClass("spr-icon-star-empty");
          if(a){
             console.log("No ha seleccionado las estrellas");
             var myInterval = setInterval(myTimer, 2000);
          }else{
            
            if(cp == 1){
              jQuery.ajax({
                  method:'post', 
                  url: 'https://decmegamers.com/grupodecme/send-mail/index.php',
                  data: {mailer: b},
                  success: function (data) {
                    var a = jQuery(".spr-form-message.spr-form-message-success").text();
                    jQuery(".spr-form-message.spr-form-message-success").html(a + " <br>" + data);               
                  } 
              });
              
              cp = cp+1;
              
            }          
              	
          }
          
        }

    });
  
  myStopFunction();
}

function myStopFunction() {
  clearInterval(myInterval);
}



/////////////////////////////////////////////////////////////////////////////////